export enum OtpScreenKey {
  LOGIN_VERIFY_SMS = 'login-verify-sms',
  SIGNUP_VERIFY_SMS = 'signup-verify-sms',
  SIGNUP_VERIFY_EMAIL = 'signup-verify-email',
  LOGIN_VERIFY_EMAIL = 'login-verify-email',
  VERIFY_SMS_REACTIVATION = 'verify-sms-reactivation',
  PHONE_CHANGE_OTP = 'phone-change-otp',
  CARD_CREDENTIALS_OTP = 'card-credentials-otp',
}
